function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { forwardRef } from 'react';
import { BaseMenu } from '../../../containers';
import { EmptyState, Option, SearchBar, Trigger } from './components';
import { useSelect } from './useSelectNew';
import { jsx as _jsx } from "react/jsx-runtime";

var SelectNewComponent = (props, ref) => {
  var {
    options,
    triggerProps,
    menuProps,
    searchBarProps,
    getOptionProps,
    emptyStateProps
  } = useSelect(props);
  return /*#__PURE__*/_jsx(BaseMenu, _objectSpread(_objectSpread({}, menuProps), {}, {
    ref: ref,
    trigger: /*#__PURE__*/_jsx(Trigger, _objectSpread({}, triggerProps)),
    header: searchBarProps && /*#__PURE__*/_jsx(SearchBar, _objectSpread({}, searchBarProps)),
    children: options.length ? options.map((option, index) => /*#__PURE__*/_jsx(Option, _objectSpread({}, getOptionProps({
      option,
      index
    })), "".concat(option.label, "-").concat(index))) : /*#__PURE__*/_jsx(EmptyState, _objectSpread({}, emptyStateProps))
  }));
};

export var SelectNew = /*#__PURE__*/forwardRef(SelectNewComponent);
SelectNew.displayName = 'SelectNew';
//# sourceMappingURL=SelectNew.js.map